import cssVars from "css-vars-ponyfill";
import "intl-pluralrules";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import main from "./main";

cssVars({});
main();
